import TagManager from 'react-gtm-module';
import { AnalyticsEventTypes } from 'services/analytics/eventNames';

export interface GAEventData {
  [key: string]: any;
}

export const trackEvent = (event: AnalyticsEventTypes, data: GAEventData) => {
  const tagManagerArgs = {
    dataLayer: {
      event,
      ...data,
    },
  };
  TagManager.dataLayer(tagManagerArgs);
};
